import * as React from 'react';
import {
	Box,
	Card,
	Typography,
	CardContent,
	Stack,
	ToggleButtonGroup,
	ToggleButton,
	MenuItem,
	TextField,
	FormControl,
	Select,
	Menu,
	Button
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PortfolioTable from "./components/MeteringTable";
import DateRangeSelector from "../../components/DateRangeSelector";
import { useTranslation } from "react-i18next";
import PortfolioChart from './components/MeteringChart'

import { ApiContext } from '../../App';
import MeteringFiltersWithCsvCard from './components/MeteringFilters';
import { MeteringSummaryCard } from './components/MeteringSummaryCard';


const Metering = (props) => {
	const { t } = useTranslation();

	const { clientInfo, portfolioView, facility } = props;
	const currencySymbol = clientInfo.currency_symbol;

	var earlierDate = new Date();
	earlierDate.setDate(earlierDate.getDate() - 7);

	const [fromDate, setFromDate] = React.useState(earlierDate);
	const [toDate, setToDate] = React.useState(new Date());
	const [timeAgg, setTimeAgg] = React.useState("h");
	const [energyType, setEnergyType] = React.useState("both");
	const [dataAgg, setDataAgg] = React.useState("location");

	const [anchorEl, setAnchorEl] = React.useState(false);
	const menuOpen = Boolean(anchorEl);

	const handleTimeAggChange = (event, newValue) => {
		setTimeAgg(newValue);
	}

	const [energyData, setEnergyData] = React.useState({});

	const [chartType, setChartType] = React.useState("cost");

	const { readingsApi } = React.useContext(ApiContext);

	const handleAPIError = () => {
		window.alert(t("Couldn't retrieve data."));
	}


	React.useEffect(() => {

		readingsApi.getEnergyData(
			fromDate,
			toDate,
			data => {
				setEnergyData(data);

			},
			() => {
				setEnergyData({});
				handleAPIError();
			},
			timeAgg,
			portfolioView ? "facility" : dataAgg,
			portfolioView ? undefined : facility,
			energyType
		)

	},
		[fromDate, toDate, timeAgg, energyType, portfolioView, facility, dataAgg]
	)

	return (
		<Box
			sx={{
				backgroundColor: (theme) =>
					theme.palette.mode === "light"
						? theme.palette.grey[100]
						: theme.palette.grey[900],
				overflow: "auto",
			}}
		>
			<Stack spacing={2} margin={3}>
				<Stack key="filters">
					<MeteringFiltersWithCsvCard
						fromDate={fromDate}
						toDate={toDate}
						setFromDate={setFromDate}
						setToDate={setToDate}
						energyType={energyType}
						setEnergyType={setEnergyType}
						dataAgg={dataAgg}
						setDataAgg={setDataAgg}
						portfolioView={portfolioView}
						energyData={energyData}
					/>
				</Stack>
				<Stack key="summary}">
					<MeteringSummaryCard energyData={energyData} currencySymbol={currencySymbol} />
				</Stack>

				<Stack key="chart">
					<Card>
						<CardContent>
							<Stack direction={"row"} >

								<Button
									onClick={(event) => setAnchorEl(event.currentTarget)}
									sx={{ textTransform: 'none' }}
									variant="text"
									disableElevation
									endIcon={<ArrowDropDownIcon />}
								>
									<Typography variant="h6">
										{(chartType === "cost") && t("Cost")}
										{(chartType === "consumption_kwh") && t("Consumption")}
										{(chartType === "co2_kg") && t("CO2")}
									</Typography>
								</Button>
								<Menu open={menuOpen} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
									<MenuItem onClick={() => { setChartType("cost"); setAnchorEl(null); }}>{t("Cost")}</MenuItem>
									<MenuItem onClick={() => { setChartType("consumption_kwh"); setAnchorEl(null); }}>{t("Consumption")}</MenuItem>
									<MenuItem onClick={() => { setChartType("co2_kg"); setAnchorEl(null); }}>{t("CO2")}</MenuItem>
								</Menu>
								<Box flexGrow={1}></Box>
								<ToggleButtonGroup
									value={timeAgg}
									exclusive
									size="small"
									onChange={handleTimeAggChange}
								>
									<ToggleButton value="h">{t("H")}</ToggleButton>
									<ToggleButton value="d">{t("D")}</ToggleButton>
									<ToggleButton value="m">{t("M")}</ToggleButton>
									<ToggleButton value="q">{t("Q")}</ToggleButton>
									<ToggleButton value="y">{t("Y")}</ToggleButton>
								</ToggleButtonGroup>

							</Stack>
							<Box height="calc(100vh - 350px)">
								<PortfolioChart
									data={energyData[chartType]}
									periods={energyData.periods}
									timeAggType={timeAgg}
								/>
							</Box>
						</CardContent>
					</Card>
				</Stack>


				<PortfolioTable energyData={energyData} currencySymbol={currencySymbol} filteredBy={dataAgg} />
			</Stack>
		</Box>
	);
};

export default Metering;
